import { stylesConfig } from "../../../utils/styles/styles";
import { Polygon, Marker, OverlayView } from "@react-google-maps/api";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../store";
import { getSelectedSectionSelector } from "../../../store/selectors/sectionSelectors";
import { IGeoPolygon } from "../../../utils/models/IGeoPoint";
import { setGlobalSectionRequest } from "../../../store/reducers/locationReducer";
import logo from "./../../../assets/SBLMarker.png";
import { getCentroid } from "../../../utils/convertions/getCentroid";
import { Fragment } from "react";
import React from "react";
import { IMapStateProps } from "../../../utils/models/IMapStateProps";
import { geoJsonGuard } from "../../../utils/functions/geoJsonGuard";
import { getSectionsSelector } from "../../../store/selectors/availabilitySelectors";
import { setRowIdSubSectionRequest } from "../../../store/reducers/availabilityReducer";
import { subSectionRequest } from "../../../store/reducers/mainAppReducer";
import { Box, Typography } from "@mui/material";
import { SBColor } from "../../locationAvailabilitiesBeachChairs/availabilitiesBeachChair/availabilitiesBeachChairTimeline";

const RowMapState = ({ setMapBounds }: IMapStateProps) => {
  const dispatch = useAppDispatch();
  const section = useSelector(getSelectedSectionSelector);
  const rows = useSelector(getSectionsSelector);
  const rowsGeoJsons = React.useMemo(
    () => rows.filter((row) => geoJsonGuard(row.geoJson)),
    [rows]
  );

  React.useEffect(() => {
    const bounds = new window.google.maps.LatLngBounds();
    if (section && rowsGeoJsons.length === 0) {
      const path =
        Object.keys(section.geoJson).length !== 0
          ? (section.geoJson as IGeoPolygon).coordinates[0].map((coord) => {
            return { lat: coord[1], lng: coord[0] };
          })
          : [{ lat: 0, lng: 0 }];
      path.forEach((point) => {
        bounds.extend({
          lat: point.lat,
          lng: point.lng,
        });
      });
    }
    if (rowsGeoJsons.length > 1) {
      rowsGeoJsons.forEach((row) => {
        let geoJson = row.geoJson;
        let centroid = getCentroid(geoJson);
        bounds.extend({
          lat: centroid.geometry.coordinates[1],
          lng: centroid.geometry.coordinates[0],
        });
      });
    } else {
      rowsGeoJsons.forEach((row) => {
        const path =
          Object.keys(row.geoJson).length !== 0
            ? (row.geoJson as IGeoPolygon).coordinates[0].map((coord) => {
              return { lat: coord[1], lng: coord[0] };
            })
            : [{ lat: 0, lng: 0 }];
        path.forEach((point) => {
          bounds.extend({
            lat: point.lat,
            lng: point.lng,
          });
        });
      });
    }
    setMapBounds(bounds);
  }, [rowsGeoJsons, setMapBounds, section]);

  return (
    <>
      {rowsGeoJsons.map((row) => {
        let geoJson = row.geoJson;
        let centroid = getCentroid(geoJson);
        if (
          geoJson &&
          Object.keys(geoJson).length === 0 &&
          geoJson.constructor === Object
        ) {
          return <></>;
        } else {
          const path = (geoJson as IGeoPolygon).coordinates[0].map((coord) => {
            return { lat: coord[1], lng: coord[0] };
          });
          var reference: Polygon | null;
          return (
            <Fragment key={`fragment-${row.id}-${row.name}`}>
              <Polygon
                ref={(ref) => {
                  reference = ref;
                }}
                path={path}
                key={`polygon-${row.id}-${row.name}`}
                onClick={() => {
                  if (section) {
                    if (reference) {
                      reference.state.polygon?.setOptions({
                        strokeColor: SBColor.white,
                        fillColor: SBColor.white,
                        fillOpacity: 0.2,
                        strokeWeight: 4,
                      });
                    }
                    setTimeout(() => {
                      dispatch(setRowIdSubSectionRequest({ rowId: row.id }));
                      dispatch(subSectionRequest({ toggle: true }));
                      dispatch(
                        setGlobalSectionRequest({
                          id: section.id,
                          hasSubsections: true,
                          rowId: row.id,
                        })
                      );
                    }, 200);
                  }
                }}
                options={{
                  strokeColor: stylesConfig.blueColor,
                  fillColor: stylesConfig.orangeColor,
                  strokeOpacity: 0.78,
                  strokeWeight: 1,
                  fillOpacity: 0.5,
                }}
              />
              <Marker
                onClick={() => {
                  if (section) {
                    dispatch(setRowIdSubSectionRequest({ rowId: row.id }));
                    dispatch(subSectionRequest({ toggle: true }));
                    dispatch(
                      setGlobalSectionRequest({
                        id: section.id,
                        hasSubsections: true,
                        rowId: row.id,
                      })
                    );
                  }
                }}
                key={`marker-${row.id}-${row.name}`}
                position={{
                  lat: centroid.geometry.coordinates[1],
                  lng: centroid.geometry.coordinates[0],
                }}
                icon={{
                  url: logo,
                  scaledSize: new google.maps.Size(50, 50),
                }}
              />
              <OverlayView
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                position={{
                  lat: centroid.geometry.coordinates[1],
                  lng: centroid.geometry.coordinates[0],
                }}
              >
                <Box
                  onClick={() => {
                    if (section) {
                      dispatch(setRowIdSubSectionRequest({ rowId: row.id }));
                      dispatch(subSectionRequest({ toggle: true }));
                      dispatch(
                        setGlobalSectionRequest({
                          id: section.id,
                          hasSubsections: true,
                          rowId: row.id,
                        })
                      );
                    }
                  }}
                  sx={{
                    width: "fit-content",
                    cursor: "pointer",
                    background: SBColor.orange,
                    borderRadius: "25px",
                    padding: "5px",
                    justifyContent: "center",
                    marginLeft: "-50%",
                    marginRight: "50%",
                  }}
                >
                  <Typography
                    sx={{
                      whiteSpace: "nowrap",
                      color: "white",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    {row.name}
                  </Typography>
                </Box>
              </OverlayView>
            </Fragment>
          );
        }
      })}
    </>
  );
};

export default RowMapState;
